import React, { useEffect, useState } from 'react';
import {
    Box,
    Text,
    Stack,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Button,
    useDisclosure,
    Flex
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { Paper } from '../../types/Writer/Paper';
import { formatDate } from '../../utils/dateTimeConversion';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import DocumentService from '../../services/DocumentService';
import { pxToRem } from "../../utils/editor.ts";
import { useTranslation } from "react-i18next";

interface PaperCardProps {
    paper: Paper;
    viewPaper?: () => void;
    continueEditing: () => void;
    discardPaper: () => void;
}

const PaperCard: React.FC<PaperCardProps> = ({ paper, continueEditing, discardPaper }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [thumbnailUrl, setThumbnailUrl] = useState<string>('');
    const { t } = useTranslation()

    useEffect(() => {
        async function getThumbnail() {
            const thumbnail = await DocumentService.getThumbnailById(paper.id).catch(() => null);
            if (thumbnail) {
                setThumbnailUrl(URL.createObjectURL(thumbnail));
            }
        }

        if (paper?.thumbnailS3Path) {
            getThumbnail();
        }
    }, [paper.id, paper.thumbnailS3Path]);

    return (
      <React.Fragment>
          <Box
            w={pxToRem(196)}
            h={pxToRem(317)}
            border={'1px solid #d3d7e2'}
            bg={'white'}
            borderWidth="1px"
            borderRadius="12px"
            overflow="hidden"
            display={'flex'}
            flexDir={'column'}
            justifyContent={'flex-end'}
            boxShadow="sm"
            bgImage={thumbnailUrl || '/static/paper_preview.png'}
            bgSize="contain" // Cover the whole box
            bgPosition="top" // Center the image
            bgRepeat="no-repeat" // Prevent the image from repeating
            onDoubleClick={continueEditing}
            onClick={continueEditing}
            cursor={'pointer'}
            transition={'all 0.5s ease'}
            _hover={{ boxShadow: 'md', borderColor: 'gray' }}
          >
              <Box bg={'#cbe4fd'} borderTop={'1px solid #d3d7e2'} pt={2} px={2} h={'70px'} borderRadius={'0 0 12px 12px'}>
                  <Text fontSize={pxToRem(14)} fontWeight="bold" fontFamily={'Lato'} overflow={'hidden'} textOverflow={'ellipsis'} whiteSpace={'nowrap'}>
                      {paper.name}
                  </Text>
                  <Flex flexDir='row' justifyContent={'space-between'} alignItems={'center'} mt={2}>
                      <Text fontSize={pxToRem(12)} color={'#333'} fontFamily={'Lato'}>{formatDate(paper.createdAt, "MM/dd/yyyy")}</Text>
                      <Stack direction="row" justifyContent="space-between" alignItems={'center'}>
                          <Menu>
                              <MenuButton
                                as={IconButton}
                                icon={<FiMoreVertical />}
                                variant="ghost"
                                aria-label="Options"
                                size={'xm'}
                                w={pxToRem(20)}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                              />
                              <MenuList>
                                  <MenuItem icon={<EditIcon />} onClick={(e) => {
                                      e.stopPropagation();
                                      continueEditing()
                                  }}>
                                      {t('paper-edit-menu')}
                                  </MenuItem>
                                  {/* <MenuItem icon={<ViewIcon />} onClick={(e) => {
                                      e.stopPropagation();
                                      viewPaper()
                                  }}>
                                      {t('paper-view-menu')}
                                  </MenuItem> */}
                                  <MenuItem icon={<DeleteIcon />} onClick={(e) =>{
                                      e.stopPropagation()
                                      onOpen()
                                  }}>
                                      {t('paper-del-menu')}
                                  </MenuItem>
                              </MenuList>
                          </Menu>
                      </Stack>
                  </Flex>
              </Box>
          </Box>
          <Modal isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent>
                  <ModalHeader>{t('delete-paper-title')}</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                      {t('delete-paper-tip')}
                  </ModalBody>

                  <ModalFooter>
                      <Button size={'sm'} variant='ghost' mr={3} onClick={onClose}>
                          {t('modal-close')}
                      </Button>
                      <Button size={'sm'} colorScheme='red' onClick={discardPaper}>
                          {t('paper-del-menu')}
                      </Button>
                  </ModalFooter>
              </ModalContent>
          </Modal>
      </React.Fragment>
    );
};

export default PaperCard;
